import { topicEntrances } from '@/mocks/home';
import { getTone } from '@/pages/home/lib/tone';
import SectionHeading from '@/pages/home/components/SectionHeading';

const tones = ['primary', 'accent', 'secondary', 'foreground'];

export default function TopicEntrances() {
  return (
    <section id="topics" className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeading
          kicker="Topic Entrances / 专题入口"
          index="07 — 四个方向"
          title="从身份出发，直达对应专题"
          desc="四个专题各自独立归档，列表与榜单互不干扰。选一个方向进去，看到的就是那一类人的全部对照记录。"
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {topicEntrances.map((topic, i) => {
            const tone = getTone(tones[i]);
            return (
              <article
                key={topic.label}
                className={`flex flex-col justify-between gap-6 border-t-2 bg-background-50 p-5 lg:border-l lg:border-l-background-200 ${
                  tone.border
                }`}
              >
                <div>
                  <p className={`font-label text-[11px] tracking-widest ${tone.text}`}>
                    专题 {String(i + 1).padStart(2, '0')}
                  </p>
                  <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950">
                    <a href="#dossier" className="transition-colors hover:text-primary-600">
                      {topic.label}
                    </a>
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{topic.desc}</p>

                  <ul className="mt-4 space-y-2 border-t border-dashed border-foreground-300 pt-4">
                    {topic.items.map((entry) => (
                      <li key={entry}>
                        <a
                          href="#dossier"
                          className="flex items-center justify-between gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600"
                        >
                          <span className="truncate">{entry}</span>
                          <i className="ri-arrow-right-s-line shrink-0 text-foreground-400" />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="flex items-center justify-between">
                  <span className="font-heading text-2xl font-bold text-foreground-950">{topic.count}</span>
                  <span className="font-label text-[11px] text-foreground-500">条归档记录</span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}